import UrlPattern from 'url-pattern';

const routePaths = {
  quickCalculator: '/',
  quickCalculatorResult: '/result/:id',
  login: '/login',
  loginByInvitation: '/login-by-invitation',
  signUp: '/sign-up/:id',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password/:token',
  verifyEmail: '/verify-email/:token',
  activateAccount: '/activate-account',
  termsOfUse: '/nutzungsbedingungen',
  dataProcessing: '/datenverarbeitung',
  expressLoanQuickStart: '/',
  expressLoan: '/express-loan',
  newProject: '/secure/new-project',
  myProjects: '/secure/projects',
  projectDetailsCalculator: '/secure/project/:id/details',
  dashboard: '/secure/project/:id/dashboard',
  lifestyleOverview: '/secure/lifestyle-overview',
  lifestyleOverviewWithProject: '/secure/project/:id/lifestyle-overview',
  lifestyleCalculator: '/secure/lifestyle-calculator',
  lifestyleCalculatorWithProject: '/secure/:id/lifestyle-calculator',
  lifestyleCalculatorEditValues: '/secure/lifestyle-calculator/edit',
  contact: '/secure/contact',
  logout: '/secure/logout',
  profile: '/secure/profile',
  plan: '/secure/project/:id/plan',
  planForm: '/secure/project/:id/plan/form',
  loan: '/secure/project/:id/loan',
  loanCalculator: '/secure/project/:id/loan/calculator',
  guestSignUp: '/secure/sign-up',
  guestLogin: '/secure/login',
  guestForgotPassword: '/secure/forgot-password',
  guestResetPassword: '/secure/reset-password/:token',
  inviteUser: '/secure/invite-user',
  invitations: '/secure/invitations/:page',
  debugMode: '/secure/project/:id/debug-mode',
};

routePaths.default = routePaths.quickCalculator;

export const routePatterns = Object.entries(routePaths).reduce(
  (p, [key, pattern]) => ({ ...p, [key]: new UrlPattern(pattern) }),
  {},
);

export default routePaths;
